import { render, staticRenderFns } from "./FeeQuery.vue?vue&type=template&id=2e67a7d1&scoped=true"
import script from "./FeeQuery.vue?vue&type=script&lang=js"
export * from "./FeeQuery.vue?vue&type=script&lang=js"
import style0 from "./FeeQuery.vue?vue&type=style&index=0&id=2e67a7d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e67a7d1",
  null
  
)

export default component.exports